import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

import PrimaryBtn from '../../atoms/buttons/primary-btn/primary-btn.component';

import './desktopNav.styles.scss';
import './mobileNav.styles.scss';

// redux actions
import { toggleDarkOverlay } from '../../../redux/darkoverlay';
import HamburgerIcon from '../../atoms/hamburger-icon/hamburger-icon.component';
import CSTMLogo from '../../../assets/logo';

// const disabledStyles = {
//   color: 'grey',
//   textDecoration: 'line-through',
//   pointerEvents: 'none'
// };

const MobileNav = () => {
  const [menuShown, setMenuShown] = useState(false);
  const [transform, setTransform] = useState('translateY(0)');

  const inactiveNavMobile = 'mobile-nav-item';
  const activeNavMobile = `${inactiveNavMobile} mobile-nav-item--selected`;

  const dispatch = useDispatch();

  const toggleMenu = function () {
    setMenuShown(!menuShown);
  };

  let prevScrollpos = window.scrollY;
  const handleNavbarScroll = function () {
    const currentScrollpos = window.scrollY;

    if (prevScrollpos > currentScrollpos) {
      setTransform('translateY(0)');
    } else {
      setTransform('translateY(-150%)');
    }

    prevScrollpos = currentScrollpos;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleNavbarScroll);

    return () => window.removeEventListener('scroll', handleNavbarScroll);
  });

  return (
    <header className="header" style={{ transform: transform }}>
      <div
        className={`${
          menuShown ? 'header-container--round' : 'header-container--semiround'
        } header-container`}
      >
        <Link to="/" className="header-logo-mobile">
          <CSTMLogo size={1} />
        </Link>
        <HamburgerIcon onClick={toggleMenu} open={menuShown} />
      </div>
      <nav className={'mobile-nav'}>
        <ul className={`${menuShown ? 'mobile-menu--active' : ''} mobile-menu`}>
          <NavLink
            className={({ isActive }) =>
              isActive ? activeNavMobile : inactiveNavMobile
            }
            to="/"
            onClick={toggleMenu}
          >
            Home
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive ? activeNavMobile : inactiveNavMobile
            }
            to="/over-ons"
            onClick={toggleMenu}
          >
            Over ons
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive ? activeNavMobile : inactiveNavMobile
            }
            to="/diensten"
            exact
            onClick={toggleMenu}
          >
            Diensten
          </NavLink>
          <p
            className="mobile-nav-item mobile-nav-item--contact"
            onClick={() => dispatch(toggleDarkOverlay())}
          >
            Contact
          </p>
        </ul>
      </nav>
    </header>
  );
};

const DesktopNav = () => {
  const dispatch = useDispatch();

  const inactiveNavDesktop = 'navigatie-item';
  const activeNavDesktop = `${inactiveNavDesktop} navigatie-item--selected`;

  return (
    <header className="navigatie-grid-container">
      <div className="navigatie-container">
        <Link className="header-logo" to="/">
          <CSTMLogo size={2} />
        </Link>
        <nav className="navigatie">
          <NavLink
            className={({ isActive }) =>
              isActive ? activeNavDesktop : inactiveNavDesktop
            }
            to="/"
          >
            Home
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive ? activeNavDesktop : inactiveNavDesktop
            }
            to="/over-ons"
          >
            Over ons
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive ? activeNavDesktop : inactiveNavDesktop
            }
            to="/diensten"
          >
            Diensten
          </NavLink>
          {/* <NavLink
            className="navigatie-item navigatie-item--disabled"
            to="/ons-werk"
            style={disabledStyles}
          >
            Our work
          </NavLink> */}
        </nav>

        <PrimaryBtn
          className="header-btn"
          text="contact"
          click={() => dispatch(toggleDarkOverlay())}
          uppercase
        />
      </div>
    </header>
  );
};

const NavBar = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = function () {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  const isMobile = width <= 900;

  return isMobile ? <MobileNav /> : <DesktopNav />;
};

export default NavBar;
